module.exports = __webpack_public_path__ + "static/img/1uav1.9a4c11ec.png";